import { messagesUploadManager } from "./MessagesUpload.slice";

export const messagesUploadActions = { ...messagesUploadManager.actions };
